import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-16 w-16 text-slate-400" />
      <h1 className="mt-4 font-head text-2xl font-extrabold text-secondary">Pago cancelado</h1>
      <p className="mt-2 text-slate-600">No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.</p>
      <Button onClick={() => navigate("/dashboard/subscription")} className="mt-6 rounded-sm bg-primary hover:bg-orange-600" data-testid="cancel-back-sub">Volver a Suscripción</Button>
    </div>
  );
}
